// The lightbox licence lives apart from `lightbox.tsx` so an app (or a test
// setup file) can configure it without loading lightGallery, its plugins and
// stylesheets. `lightbox.tsx` re-exports `configureLightbox`.

let globalLicenseKey: string | undefined;

/**
 * Set the lightGallery licence once per app (e.g. in `main.tsx`, next to the
 * AG Grid licence). A per-instance `licenseKey` prop still wins.
 */
export function configureLightbox(options: { licenseKey?: string | undefined }): void {
  globalLicenseKey = options.licenseKey || undefined;
}

/** The key set by {@link configureLightbox}, if any. */
export function getConfiguredLightboxLicenseKey(): string | undefined {
  return globalLicenseKey;
}
